import { useState, useEffect } from 'react';

const useIsOnline = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const setOnline = () => {
            setIsOnline(true);
        };

        const setOffline = () => {
            setIsOnline(false);
        };

        window?.addEventListener('online', setOnline);
        window?.addEventListener('offline', setOffline);

        return () => {
            window?.removeEventListener('online', setOnline);
            window?.removeEventListener('offline', setOffline);
        };
    }, []);

    return isOnline;
};

export default useIsOnline;
